import mutations from "./mutations.js";
import actions from "./actions.js";
import getters from "./getters.js";

export default {
  namespaced: true,

  state() {
    return {
      chats: [],
      paginations: {
        current_page: 1,
        last_page: 2,
      },
    };
  },
  mutations,
  actions,
  getters,
};
